const PASSPORT_RATIO = 35 / 45
const CARD_WIDTH_PT = (85.6 * 72) / 25.4 // ≈ 242 pt
const CARD_HEIGHT_PT = (54 * 72) / 25.4 // ≈ 153 pt

export default {
  PASSPORT_RATIO,
  CARD_HEIGHT_PT,
  CARD_WIDTH_PT,
}
